/**
 * @generated SignedSource<<bfbb44025a5e209e6786e002fc25e257>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PackageDateStatus = "ACTIVE" | "DRAFT" | "EXPIRED";
import { FragmentRefs } from "relay-runtime";
export type PackageDateStatus_packageDate$data = {
  readonly status: PackageDateStatus;
  readonly " $fragmentType": "PackageDateStatus_packageDate";
};
export type PackageDateStatus_packageDate$key = {
  readonly " $data"?: PackageDateStatus_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateStatus_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateStatus_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "90de3c10422b60013d2dd60fab0a7dc8";

export default node;
